import { SPOT_PURCHASES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/spot_purchases_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';
import { SPOT_PURCHASES_FOR_WO_TC } from '../constants/SpotPurchaseStatuses';

const initialState: any = standardInitialStateGenerator([SPOT_PURCHASES_FOR_WO_TC]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
